<template>
  <div>
    <span :class="statusClass"> {{ $t(`list.statuses.${shipment.status}`) }} </span>
    /
    {{ $t(`list.steps.${shipment.step}`) }}
  </div>
</template>

<script>
export default {
  name: 'ShipmentStatusComp',

  props: {
    shipment: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      dangerStatuses: ['error', 'canceled']
    }
  },

  components: {
  },

  computed: {
    hasDangerStatus () {
      if (this.dangerStatuses.indexOf(this.shipment.status) === -1) { return false }

      return true
    },

    hasWarningStatus () {
      return this.shipment.status === 'pending_cancellation'
    },

    statusClass () {
      return {
        'red--text': this.hasDangerStatus,
        'orange--text': this.hasWarningStatus
      }
    }
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
